export default function isValidAuthProvider(provider: string | null) {
  return ["google", "microsoft"].includes(provider || "");
}
